import { render, staticRenderFns } from "./DialogAudioPlayer.vue?vue&type=template&id=433ecb68&scoped=true&"
import script from "./DialogAudioPlayer.vue?vue&type=script&lang=js&"
export * from "./DialogAudioPlayer.vue?vue&type=script&lang=js&"
import style0 from "./DialogAudioPlayer.vue?vue&type=style&index=0&id=433ecb68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433ecb68",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
